import {
  useMutation,
  UseMutationResult,
  useQueries,
  UseQueryResult,
} from '@taxdown/zeno-sama-query';
import { AxiosError } from 'axios';
import i18n from 'Services/i18n';
import { getErrorDetail } from 'Services/errors';
import Notify, { AlertTypes } from 'Services/notification';
import SatService from 'Services/sat';
import EventService from 'Services/events';
import { formatPDF } from 'Utils/formatPdf';
import { TAX_YEAR } from 'Config';
import { EfirmaType, ResponseType } from 'Types/common';
import { AccountQueryKey, CredentialsType } from '../../types';

export const useFetchSaveEfirmaMutation = (
  setLoading: () => void
): UseMutationResult<ResponseType<EfirmaType>, EfirmaType, unknown> =>
  useMutation([AccountQueryKey.SAVE_EFIRMA_FORM], SatService.saveEfirmaUser, {
    onSuccess: () => {
      EventService.taxAgencyCredentialUpdate(TAX_YEAR, CredentialsType.EFIRMA);
      Notify.sendNotification(i18n.t('common:Sat.data.validate'), AlertTypes.success);
      setLoading();
    },
    onError: (err: AxiosError) => {
      if (err) {
        Notify.sendNotification(getErrorDetail(err), AlertTypes.error);
        setLoading();
      }
    },
  });

export const useFetchGetBase64 = (url: string[]): UseQueryResult<string, unknown>[] =>
  useQueries({
    queries: url.map(item => {
      return {
        queryKey: ['useGetBase64', item],
        queryFn: (): Promise<string> => formatPDF(item),
        onSuccess: data => {
          return data;
        },
        enabled: Boolean(item),
        refetchOnWindowFocus: false,
        cacheTime: 0,
      };
    }),
  });
